import { displayActiveEmployees } from "./displays/display-active-employees";
import { saveEmployeeFilter } from "../../infrastructure/employees-filter";

export async function searchActiveEmployees(value) {
  saveEmployeeFilter({ forState: "active", searchString: value });

  displayActiveEmployees();
}
